import { useLocation } from 'react-router';

export default function useQuery() {
  const params = useLocation().search;

  return new URLSearchParams(params);
}
